import { Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { Illustration } from '@/components/Illustration/Illustration'

export const ContinueOnComputerPage = observer(() => {
  const store = useContext(StoreContext)
  const { switchToMobile: trans } = store.TranslationsState.translations

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type="device-not-switched" />

      <Header className="m-0-0-30">{trans.continueOnComputerPage?.header}</Header>

      <p className="generic__paragraph-centered m-0-0-30">
        {trans.continueOnComputerPage?.description}
      </p>
    </div>
  )
})
